import './highlight.scss';

import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

const COMPONENT_NAME = 'highlight';
// const EVENT_KEY = COMPONENT_NAME;
const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_SLIDER: 'highlight__slider',
  ELEMENT_SLIDER_ITEM: 'highlight__slider__item',
  ELEMENT_SLIDE: 'highlight__slide',
};

/**
 * version    1.0
 * class      <type> (Highlight)
 */
export class Highlight {
  constructor($container = $('body')) {
    const self = this;

    // find elements
    this._els = {};
    this._els.container = $container;
    this._els.highlight = this._els.container.find(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.highlight.each(function () {
        self._initSingleInstance($(this));
      });
    });
  }

  // private methods

  _initSingleInstance($instanceEl) {
    const self = this;
    const isMuseoSlider = self._els.highlight.hasClass('highlight--museo-slider');

    if (isMuseoSlider) {
      self._initMuseoSlider($instanceEl);
    } else {
      self._initSlider($instanceEl);
      TextColorCheck._checkBackground($instanceEl);
    }

    $instanceEl.find(`.${BEM.ELEMENT_SLIDE}`).each(function () {
      const $slide = $(this);
      self._initSlideAnchorOverlay($slide);
    });
  }

  // init the slider in case the instance contains more than one slide
  _initSlider($instanceEl) {
    const $sliderItems = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);

    const optionsSlider = {
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      centeredMode: true,
      variableWidth: true,
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg role="img" class="svg-icon svg-icon--arrow-long-right" title="Next"><use xlink:href="#sprite-arrow-long-right"></use></svg></button>',
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg role="img" class="svg-icon svg-icon--arrow-long-left" title="Previous"><use xlink:href="#sprite-arrow-long-left"></use></svg></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    };

    if ($sliderItems.length > 1) {
      $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`).slick(optionsSlider);
    }
  }

  _initMuseoSlider($instanceEl) {
    const $sliderItems = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);

    const optionsSlider = {
      infinite: false,
      slidesToShow: $instanceEl.hasClass('highlight--museo-slider--3-card') ? 3 : 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      variableWidth: true,
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg role="img" class="svg-icon svg-icon--arrow-long-right" title="Next"><use xlink:href="#sprite-arrow-long-right"></use></svg></button>',
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg role="img" class="svg-icon svg-icon--arrow-long-left" title="Previous"><use xlink:href="#sprite-arrow-long-left"></use></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    };

    if ($sliderItems.length > 1) {
      $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`).slick(optionsSlider);
    }
  }

  // if there is only one cta, make the whole slide clickable
  _initSlideAnchorOverlay($slide) {
    const $cta = $slide.find(`.${BEM.ELEMENT_FOOT} .btn`);
    if ($cta.length === 1) {
      const $anchorOverlay = $cta.clone(true);
      $anchorOverlay.addClass('highlight__anchor-overlay');
      $slide.append($anchorOverlay);
    }
  }
}
